import * as api from "services/api";
import { getErrors } from "helpers/error";
import { Callback } from "Types/Callback";
import IUser from "Types/User";
import { State } from "store/reducers";
import ls from "Localization";
import { AsYouType } from "libphonenumber-js";

export const CREATE_USER = "[USER CREATE] CREATE_USER";
export const CREATE_USER_SUCCESS = "[USER CREATE] CREATE_USER_SUCCESS";
export const CREATE_USER_FAILED = "[USER CREATE] CREATE_USER_FAILED";

export const SET_VALUE = "[USER CREATE] SET_VALUE";
export const CLEAR_VALUES = "[USER CREATE] CLEAR_VALUES";

export function setValue(payload: any) {
	return { type: SET_VALUE, payload };
}

export function clearValues() {
	return { type: CLEAR_VALUES };
}

export function createUser(callback: Callback<IUser>) {
	return async (dispatch: any, getState: any) => {
		dispatch({ type: CREATE_USER });

		try {
			const { login, userCreate } = getState() as State;

			const {
				email,
				name,
				lastname,
				role,
				cpf,
				userStatus,
				phoneNumber,
				birthDate,
				address,
				mei
			} = userCreate;

			const errors: any = {};

			if (!name) errors.name = ls.required;
			if (!lastname) errors.lastname = ls.required;
			if (!email) errors.email = ls.required;
			if (!address.city) errors.city = ls.required;
			if (!address.state) errors.state = ls.required;
			if (!role) errors.role = ls.required;

			dispatch({ type: SET_VALUE, payload: { errors } });

			if (Object.keys(errors).length)
				return dispatch({ type: SET_VALUE, payload: { loading: false } });

			const model = {
				email,
				name,
				lastname,
				role,
				cpf,
				userStatus,
				phoneNumber: phoneNumber
					? new AsYouType().input(`+55${phoneNumber}`)
					: "",
				birthDate,
				address,
				mei: role === "admin" ? null : mei
			};

			const response = await api.sendPost("/User/Admin", model, {
				Authorization: `Bearer ${login.token}`
			});

			if (response.ok) {
				dispatch({
					type: CREATE_USER_SUCCESS
				});

				callback && callback();
			} else {
				const result = await response.json();

				const errors = getErrors(result);

				dispatch({
					type: CREATE_USER_FAILED,
					payload: errors
				});
				callback && callback(errors);
			}
		} catch (error) {
			callback && callback(error);

			return dispatch({
				type: CREATE_USER_FAILED,
				payload: {
					error: "Connection error"
				}
			});
		}
	};
}
